import { cloneDeep } from 'lodash';

import { SUB_MENU } from 'PointOfSale/modules/common/constants';
import * as types from 'PointOfSale/modules/servingOptions/state/types';
import { POS_MIN_TIME_DELAY } from 'Common/Constants';
import * as constants from 'PointOfSale/mockData';
import * as QueueTypes from 'PointOfSale/modules/queue/state/types';
import {
  QueueStatusEnum,
  SessionTypes,
} from 'PointOfSale/modules/common/constants';

import * as ServingOptionsSelectors from './selector';
import * as IndividualServingSelectors from 'PointOfSale/modules/individualServing/state/selectors';

export const getServingSubMenuItems = () => ({
  type: types.GET_SERVING_SUBMENU_ITEMS,
  payload: cloneDeep(SUB_MENU),
});

export const setStartingCash = cash => ({
  type: types.SET_STARTING_CASH,
  payload: cash,
});

export const setCurrentSession = currentSession => ({
  type: types.SET_CURRENT_SESSION,
  payload: currentSession,
});

export const getCEPTypes = () => dispatch => {
  return dispatch({
    type: types.GET_CEP_TYPES,
    payload: constants.CEP_TYPES,
  });
};

export const onSessionCreated = currentSession => dispatch => {
  const sessionObj = {
    autoServe: currentSession.autoServe,
    quickServeItem: currentSession.quickServeSelectedItem,
    timeInterval: currentSession.timeInterval,
  };

  if (SessionTypes.Queue === currentSession.type) {
    sessionObj.queueType = currentSession.queueType;
  }

  const session = {
    activeSession: currentSession.type,
    sessions: {
      [currentSession.type]: sessionObj,
    },
  };

  if (currentSession.type === SessionTypes.Queue) {
    // user selects autoserve, set to paused or off on start
    dispatch({
      type: QueueTypes.CHANGE_QUEUE_STATUS,
      payload: currentSession.autoServe
        ? QueueStatusEnum.PAUSED
        : QueueStatusEnum.OFF,
    });
  }

  return dispatch({
    type: types.ON_SESSION_CREATED,
    payload: session,
  });
};

export const clearCurrentSession = () => dispatch => {
  return dispatch({
    type: types.CLEAR_CURRENT_SESSION,
    payload: null,
  });
};

export const setSelectedSubMenu = (
  selectedServingSubMenu, // { Id: 1, Description: 'Auto Serve', selected: false }
  currentSelectedMenu // Queue
) => (dispatch, getState) => {
  const state = getState();

  const servingSubMenuItems = ServingOptionsSelectors.getSubMenuItems(state);
  const currentSession = cloneDeep(
    ServingOptionsSelectors.getCurrentSession(state)
  );

  if (selectedServingSubMenu.Description === 'Auto Serve') {
    if (!selectedServingSubMenu.selected) {
      servingSubMenuItems[currentSelectedMenu].map(item => {
        return (item.selected = true);
      });
      currentSession['autoServe'] = true;
      currentSession['quickServeItem'] = true;
      if (currentSession.quickServeSelectedItem === null)
        currentSession['quickServeSelectedItem'] = '';
    } else {
      currentSession['autoServe'] = false;
      servingSubMenuItems[currentSelectedMenu].forEach(item => {
        if (item.Description === selectedServingSubMenu.Description) {
          item.selected = !currentSession['quickServeItem'];
        }
      });
    }
  } else if (
    selectedServingSubMenu.Description === 'Quick Serve Items' &&
    selectedServingSubMenu.selected
  ) {
    servingSubMenuItems[currentSelectedMenu].map(item => {
      return (item.selected = false);
    });
    currentSession['autoServe'] = false;
    currentSession['quickServeItem'] = false;
    currentSession['quickServeSelectedItem'] = '';
  } else {
    servingSubMenuItems[currentSelectedMenu].map(item => {
      if (item.Description === selectedServingSubMenu.Description) {
        item.selected = true;
      }
      return item;
    });
    currentSession['autoServe'] = false;
    currentSession['quickServeItem'] = true;
    currentSession['quickServeSelectedItem'] = '';
  }
  dispatch(setCurrentSession(currentSession));

  dispatch({
    type: types.GET_SERVING_SUBMENU_ITEMS,
    payload: servingSubMenuItems,
  });
};

export const setQuickServeFoodItem = selectedFoodItem => (
  dispatch,
  getState
) => {
  const state = getState();
  const currentSession = cloneDeep(
    ServingOptionsSelectors.getCurrentSession(state)
  );
  currentSession['quickServeSelectedItem'] = selectedFoodItem;
  dispatch(setCurrentSession(currentSession));
};

export const setTimeInterval = type => (dispatch, getState) => {
  const state = getState();
  const currentSession = cloneDeep(
    ServingOptionsSelectors.getCurrentSession(state)
  );
  let timeDelay = currentSession.timeInterval;

  timeDelay = timeDelay + type;
  if (timeDelay < POS_MIN_TIME_DELAY) {
    timeDelay = POS_MIN_TIME_DELAY;
  }

  currentSession['timeInterval'] = timeDelay;

  dispatch(setCurrentSession(currentSession));
};
export const onSessionAdd = currentSession => (dispatch, getState) => {
  const state = getState();
  const sessionsState = IndividualServingSelectors.getSessions(state);

  const sessionObj = {
    autoServe: currentSession.autoServe,
    quickServeItem: currentSession.quickServeSelectedItem,
    timeInterval: currentSession.timeInterval,
  };

  if (SessionTypes.Queue === currentSession.type) {
    sessionObj.queueType = currentSession.queueType;
  }
  const session = {
    activeSession: currentSession.type,
    sessions: {
      ...sessionsState,
      [currentSession.type]: sessionObj,
    },
  };
  dispatch({
    type: types.ON_SESSION_ADD,
    payload: session,
  });
};
export const setActiveSession = activeSession => ({
  type: types.SET_ACTIVE_SESSION,
  payload: activeSession,
});

export const setQuickServeItem = quickServeItem => ({
  type: types.CHANGE_QUICK_SERVE_ITEM,
  payload: quickServeItem,
});

export const setActiveSessionInterval = seconds => ({
  type: types.SET_ACTIVE_SESSION_INTERVAL,
  payload: seconds,
});

export const setAutoServeOnOff = isOn => ({
  type: types.SET_AUTOSERVE_ON_OFF,
  payload: isOn,
});



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/state/actions.js